/* tiajô — animações do tema */
(function () {
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });
  document.querySelectorAll('.tj-reveal').forEach(function (el) { io.observe(el); });

  if (reduced) return;

  document.querySelectorAll('[data-tj-hero]').forEach(function (wrap) {
    var img = wrap.querySelector('[data-tj-hero-img]');
    var veil = wrap.querySelector('[data-tj-hero-veil]');
    var text = wrap.querySelector('[data-tj-hero-text]');
    var raf = null;
    function onScroll() {
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = null;
        var total = wrap.offsetHeight - window.innerHeight;
        var p = Math.min(1, Math.max(0, -wrap.getBoundingClientRect().top / Math.max(1, total)));
        if (img) { img.style.transform = 'scale(' + (1 + p * 0.18) + ')'; img.style.filter = 'saturate(1.18) contrast(1.08) brightness(' + (0.97 - p * 0.35) + ')'; }
        if (veil) veil.style.opacity = String(p * 0.55);
        if (text) {
          text.style.transform = 'translateY(calc(-46% - ' + (p * 90) + 'px))';
          text.style.opacity = String(1 - p * 1.4);
        }
      });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  });

  document.querySelectorAll('[data-tj-drum]').forEach(function (wrap) {
    var items = Array.prototype.slice.call(wrap.querySelectorAll('[data-tj-drum-item]'));
    var infos = Array.prototype.slice.call(wrap.querySelectorAll('[data-tj-drum-info]'));
    var counter = wrap.querySelector('[data-tj-drum-counter]');
    var bar = wrap.querySelector('[data-tj-drum-bar]');
    var N = items.length;
    if (!N) return;
    var active = -1, raf = null;
    function onScroll() {
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = null;
        var total = wrap.offsetHeight - window.innerHeight;
        var p = Math.min(1, Math.max(0, -wrap.getBoundingClientRect().top / Math.max(1, total)));
        var pos = p * (N - 1);
        var act = Math.round(pos);
        items.forEach(function (el, i) {
          var off = i - pos, a = Math.abs(off);
          el.style.transform = 'translateX(' + (off * 78) + '%) translateY(' + (a * 9) + 'vh) rotate(' + (off * 22) + 'deg) scale(' + Math.max(0.7, 1 - a * 0.18) + ')';
          el.style.opacity = String(Math.max(0, 1 - a * 1.15));
          el.style.zIndex = String(100 - Math.round(a * 10));
          el.style.visibility = a > 1.25 ? 'hidden' : 'visible';
        });
        if (act !== active) {
          active = act;
          infos.forEach(function (el, i) {
            el.style.display = i === active ? '' : 'none';
            if (i === active) { el.style.animation = 'none'; void el.offsetWidth; el.style.animation = 'tjSlideFade 420ms cubic-bezier(0.25,0.1,0.25,1)'; }
          });
          if (counter) counter.textContent = String(active + 1).padStart(2, '0');
          if (bar) bar.style.width = ((active + 1) / N) * 100 + '%';
        }
      });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    var canvas = wrap.querySelector('[data-tj-beans]');
    if (!canvas) return;
    var ctx = canvas.getContext('2d');
    var DPR = Math.min(2, window.devicePixelRatio || 1);
    var W = 0, H = 0;
    function resize() {
      W = canvas.clientWidth; H = canvas.clientHeight;
      canvas.width = W * DPR; canvas.height = H * DPR;
      ctx.setTransform(DPR, 0, 0, DPR, 0, 0);
    }
    resize();
    window.addEventListener('resize', resize);
    function rand(seed) { var x = Math.sin(seed * 127.1 + 311.7) * 43758.5453; return x - Math.floor(x); }
    var BEANS = [];
    for (var i = 0; i < 26; i++) BEANS.push({
      x: rand(i + 1), speed: 0.55 + rand(i + 7) * 0.9, size: 9 + rand(i + 13) * 14,
      drift: (rand(i + 19) - 0.5) * 0.12, spin: (rand(i + 29) - 0.5) * 6,
      tone: rand(i + 37), delay: rand(i + 43) * 0.35
    });
    function drawBean(x, y, s, rot, alpha, tone) {
      ctx.save(); ctx.translate(x, y); ctx.rotate(rot); ctx.globalAlpha = alpha;
      ctx.fillStyle = tone > 0.6 ? '#5C4A3E' : tone > 0.3 ? '#4A382E' : '#3B2C24';
      ctx.beginPath(); ctx.ellipse(0, 0, s * 0.62, s, 0, 0, Math.PI * 2); ctx.fill();
      ctx.strokeStyle = 'rgba(43,30,24,0.85)'; ctx.lineWidth = Math.max(1, s * 0.09);
      ctx.beginPath(); ctx.moveTo(0, -s * 0.88);
      ctx.bezierCurveTo(-s * 0.3, -s * 0.3, s * 0.3, s * 0.3, 0, s * 0.88); ctx.stroke();
      ctx.restore();
    }
    var raf2 = null;
    function render() {
      raf2 = null;
      var total = wrap.offsetHeight - window.innerHeight;
      var p = Math.min(1, Math.max(0, -wrap.getBoundingClientRect().top / Math.max(1, total)));
      ctx.clearRect(0, 0, W, H);
      if (p <= 0 || p >= 1) return;
      BEANS.forEach(function (b, i) {
        var fall = (p - b.delay) * b.speed;
        if (fall <= 0) return;
        var y = fall * (H + 160) - 80;
        if (y > H + 80) return;
        var x = (b.x + Math.sin(fall * 5 + i) * b.drift) * W;
        var fadeIn = Math.min(1, fall * 6);
        var fadeOut = y > H - 140 ? Math.max(0, (H - y) / 140) : 1;
        drawBean(x, y, b.size, fall * b.spin, 0.34 * fadeIn * fadeOut, b.tone);
      });
    }
    window.addEventListener('scroll', function () { if (!raf2) raf2 = requestAnimationFrame(render); }, { passive: true });
    render();
  });
})();
/* pílulas de gramatura nos cards (home, coleção, busca) */
(function(){
  document.addEventListener('click', function(e){
    var pill = e.target.closest('[data-tj-pill]');
    if (!pill) return;
    e.preventDefault();
    var card = pill.closest('.tj-card');
    if (!card) return;
    var priceEl = card.querySelector('[data-tj-price]');
    var bg = priceEl ? priceEl.getAttribute('data-bg') : 'transparent';
    card.querySelectorAll('[data-tj-pill]').forEach(function(p){
      var on = p === pill;
      p.setAttribute('aria-pressed', on ? 'true' : 'false');
      p.style.background = on ? bg : 'transparent';
      p.style.borderColor = on ? 'var(--espresso-70)' : 'var(--hairline)';
    });
    if (priceEl) priceEl.textContent = pill.getAttribute('data-price');
    var input = card.querySelector('[data-tj-vid]');
    if (input) input.value = pill.getAttribute('data-id');
  });
})();
